<div class="pc-page-shell">
<!-- Side Drawer Filter -->
<div class="filter-container" [class.open]="isFilterOpen">
  <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode(), 'light-filter': !isDarkMode() }">

    <!-- Header -->
    <div class="filter-header">
    <div class="filter-header__title">
      <mat-icon aria-hidden="true">filter_alt</mat-icon>
      <span>Table Filter</span>
    </div>
      <mat-icon class="close-btn" (click)="isFilterOpen = false">
        close
      </mat-icon>
    </div>

    <!-- Body -->
    <form [formGroup]="retriveForm" class="filter-body">

      <!-- Created Date -->
      <div class="filter-section">
        <h4>Created Date</h4>

        <app-custom-date-picker
          [label]="'Created At From'"
          [controlname]="retriveForm.controls['createdAtFrom']">
        </app-custom-date-picker>

        <app-custom-date-picker
          [label]="'Created At To'"
          [controlname]="retriveForm.controls['createdAtTo']">
        </app-custom-date-picker>
      </div>

      <!-- Voyage Date -->
      <div class="filter-section">
        <h4>Voyage Date</h4>

        <app-custom-date-picker
          [label]="'From'"
          [controlname]="retriveForm.controls['from']">
        </app-custom-date-picker>

        <app-custom-date-picker
          [label]="'To'"
          [controlname]="retriveForm.controls['to']">
        </app-custom-date-picker>
      </div>

      <!-- Client -->
      <div class="filter-section" *ngIf="username === 'Meraki - Operations'">
        <h4>Client</h4>

        <app-pc-multi-select-filter
          [lightMode]="!isDarkMode()"
          label=""
          placeholder="Select Client"
          allLabel="All"
          [options]="clientOptions"
          [(selected)]="selectedClients">
        </app-pc-multi-select-filter>
      </div>

      <!-- Vessel Details -->
      <div class="filter-section">
        <h4>Vessel Details</h4>

        <app-custom-input
          label="IMO Number"
          [controlname]="retriveForm.controls['imoNumber']">
        </app-custom-input>

        <label
          class="shipNameLabel"
          [ngClass]="{ 'dark-label': isDarkMode() }">
          Ship Name
        </label>

        <input
          type="text"
          class="form-control"
          id="shipName"
          formControlName="shipName"
          (input)="filterShipNames($event)"
          [matAutocomplete]="autoShip"
        />

        <mat-autocomplete #autoShip="matAutocomplete">
          <mat-option
            *ngFor="let ship of shipNameSuggestions"
            [value]="ship.vessel_name">
            {{ ship.vessel_name }}
          </mat-option>
        </mat-autocomplete>
      </div>

    </form>

    <!-- Footer -->
    <div class="filter-footer">
      <button
        type="button"
        class="btn clear-btn"
        (click)="clearClick()">
        <mat-icon>clear_all</mat-icon>
        Clear Filter
      </button>

      <button
        type="button"
        class="btn apply-btn"
        (click)="filterClick()">
        <mat-icon>filter_list</mat-icon>
        Apply Filter
      </button>
    </div>

  </div>
</div>
<div class="filter-overlay" *ngIf="isFilterOpen" (click)="isFilterOpen = false"></div>

<div class="container">
 <mat-icon
  class="filter-top-btn"
  (click)="isFilterOpen = true"
  matTooltip="Table Filter">
  filter_list
</mat-icon>

  <div class="table-container scroll-bar">
    <table class="mat-elevation-z8" id="style-4" matSort [ngClass]="{ 'dark-table': isDarkMode() }">
      <thead class="fixed-header">
        <tr>
          <th class="th-text-centersno">S.No</th>
          <th class="th-text-center" mat-sort-header="vesselName">
            Vessel Name
          </th>
          <th class="th-text-center" mat-sort-header="imoNumber">IMO Number</th>
          <th mat-sort-header="eosp_datetime">EOSP (UTC)</th>
          <th mat-sort-header="cosp_datetime">COSP (UTC)</th>
          <th class="th-text-center" mat-sort-header="resolved_port_name">Port Name</th>
          <th class="th-text-center1" mat-sort-header="cargo_operation" *ngIf="userName !== 'Zeronorth ZN'">
            Cargo Operation
          </th>
          <th mat-sort-header="updated_at">Created At (UTC)</th>
          <th>Report</th>
          <th *ngIf="isAdminUser()">Actions</th>
          <th class="th-text-center" *ngIf="isMerakiOperations()">Insights</th>
        </tr>
      </thead>
      <tbody *ngIf="isLoading">
  <tr *ngFor="let dummy of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="skeleton-row">
    <td><div class="skeleton-bar sno-skeleton"></div></td>
    <td class="fixed-col"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td *ngIf="userName !== 'Zeronorth ZN'"><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar"></div></td>
    <td><div class="skeleton-bar icon-skeleton"></div></td>
    <td *ngIf="isAdminUser()"><div class="skeleton-bar icon-skeleton"></div></td>
    <td class="insights-col" *ngIf="isMerakiOperations()"><div class="skeleton-bar circle-skeleton"></div></td>
  </tr>
</tbody>
      <tbody *ngIf="!isLoading">
        <tr *ngFor="let element of paginatedData; let rowIndex = index; trackBy: trackByRow">
          <td class="sno">{{ rowIndex + 1 }}</td>

          <td class="fixed-col" matTooltip="{{ element._pcVesselName }}">
            {{ element._pcVesselNameShort }}
          </td>
          <td>
            {{ element.vessel_imo }}
          </td>
          <td>{{ element._pcEosp }}</td>
          <td>{{ element._pcCosp }}</td>
          <td matTooltip="{{ element._pcPortUpper }}">{{ element._pcPortShort }}</td>

          <td>{{ element._pcCargoOperation }}</td>
          <td>{{ element._pcUpdatedAt }}</td>
          <td>
            <button
              mat-icon-button
              (click)="openReportDownloadModal(element)"
              *ngIf="element._pcHasReport"
            >
              <mat-icon>download</mat-icon>
            </button>
            <p *ngIf="!element._pcHasReport" class="inProgress">
              In progress
            </p>
          </td>
          <td *ngIf="isAdminUser()">
            <button mat-icon-button class="delete-icon-btn" (click)="confirmAndDelete(element, $event)" aria-label="Delete request" matTooltip="Delete">
              <mat-icon color="warn">delete</mat-icon>
            </button>
          </td>
          <td class="insights-col" *ngIf="isMerakiOperations()">
            <button
              type="button"
              class="ai-btn"
              [class.ai-btn--waiting]="!element._pcHasReport"
              (click)="openInsights(element, $event)"
              [matTooltip]="element._pcHasReport ? 'View AI insights' : 'Insights available when report is ready'"
              matTooltipPosition="above"
              aria-label="View AI insights">
              <mat-icon class="ai-icon">auto_awesome</mat-icon>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator [length]="filteredData?.length || RetriveData.length" [pageSizeOptions]="[100]"
    [pageSize]="itemsPerPage" (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }"
    showFirstLastButtons>
  </mat-paginator>
  <div class="text-right">
    <button class="btn btn-light hover-button mail" style="margin-right: 5px" (click)="exportClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>
</div>
</div>